import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570a6587"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finding-thresholded flex flex-grow align-center" }
const _hoisted_2 = { class: "finding-value flex-grow" }
const _hoisted_3 = { key: 1 }

import IbIcons from "@/components/icons/ib-icons.vue";
import { Insight } from '@/models/insight';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Threshold',
  props: {
  insight: {
    type: Object as PropType<Insight>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IbIcons, {
      icon: "ai",
      size: "14",
      class: "ai-icon"
    }),
    _createElementVNode("div", _hoisted_2, [
      (__props.insight.likelihood)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([__props.insight.likelihood, "fs-12 finding flex flex-grow justify-center align-center"])
          }, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)(`insights.likelihood.${__props.insight.likelihood}`)), 1)
          ], 2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('insights.na')), 1))
    ])
  ]))
}
}

})